<!-- @veltra/icons generated sha256:2be3617a1e31d5db gen:8 source:src/svg/normal/rollback.svg -->
<script setup lang="ts">
defineOptions({ name: 'Rollback' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m4.207 5 1.291-1.29a.506.506 0 0 0-.009-.72.49.49 0 0 0-.7.014L2.65 5.143a.51.51 0 0 0 0 .714l2.14 2.14a.51.51 0 0 0 .713 0l.008-.008a.49.49 0 0 0-.013-.698L4.208 6H10a3 3 0 0 1 0 6H5.496a.5.5 0 0 0 0 1H10a4 4 0 0 0 0-8z"
    />
  </svg>
</template>
